export default __webpack_public_path__ + "static/media/IE.524e82eb.svg";